// Tassi Mobility Safe - Rate Table (Local Persistence Support)

export const RATE_DIVISOR = 1000; 
const STORAGE_KEY = 'mobility_safe_rates';

const defaultRateTable = {
  "1": {
    Base: { 12: 4.03, 24: 7.67, 36: 10.90, 48: 13.32, 60: 15.75 },
    Medium: { 12: 11.33, 24: 21.54, 36: 30.61, 48: 37.41, 60: 44.21 },
    Collisione: { 12: 17.52, 24: 33.29, 36: 47.30, 48: 57.81, 60: 68.32 },
    Kasko: { 12: 27.53, 24: 52.31, 36: 74.34, 48: 90.86, 60: 107.38 }
  },
  "2": {
    Base: { 12: 4.58, 24: 8.70, 36: 12.36, 48: 15.11, 60: 17.85 },
    Medium: { 12: 9.10, 24: 17.31, 36: 24.60, 48: 30.06, 60: 35.52 },
    Collisione: { 12: 15.39, 24: 29.22, 36: 41.53, 48: 50.76, 60: 59.99 },
    Kasko: { 12: 25.55, 24: 48.54, 36: 68.97, 48: 84.29, 60: 99.62 }
  },
  "3": {
    Base: { 12: 6.41, 24: 12.17, 36: 17.29, 48: 21.13, 60: 24.97 },
    Medium: { 12: 16.11, 24: 30.59, 36: 43.48, 48: 53.14, 60: 62.80 },
    Collisione: { 12: 21.86, 24: 41.54, 36: 59.03, 48: 72.14, 60: 85.26 },
    Kasko: { 12: 31.19, 24: 59.27, 36: 84.23, 48: 102.93, 60: 121.65 }
  },
  "4": {
    Base: { 12: 9.45, 24: 17.95, 36: 25.52, 48: 31.18, 60: 36.85 },
    Medium: { 12: 12.01, 24: 22.83, 36: 32.43, 48: 39.64, 60: 46.85 },
    Collisione: { 12: 18.30, 24: 34.79, 36: 49.43, 48: 60.42, 60: 71.40 },
    Kasko: { 12: 28.50, 24: 54.17, 36: 76.97, 48: 94.08, 60: 111.18 }
  },
  "3bis": {
    Base: { 12: 2.89, 24: 5.48, 36: 7.80, 48: 9.54, 60: 11.27 },
    Medium: { 12: 31.52, 24: 59.88, 36: 85.09, 48: 104.00, 60: 122.91 },
    Collisione: { 12: 37.27, 24: 70.82, 36: 100.65, 48: 123.01, 60: 145.37 },
    Kasko: { 12: 46.61, 24: 88.56, 36: 125.84, 48: 153.81, 60: 181.77 }
  }
};

// Singleton to hold active rates
let activeRates = null;

export const loadRateTable = () => {
    try {
        const saved = localStorage.getItem(STORAGE_KEY);
        activeRates = saved ? JSON.parse(saved) : defaultRateTable;
    } catch (e) {
        activeRates = defaultRateTable;
    }
    return activeRates;
};

export const saveRateTable = (newRates) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newRates));
    activeRates = newRates;
};

export const getRateTable = () => {
    if (!activeRates) loadRateTable();
    return activeRates;
};

export const getRate = (zone, packageType, duration) => {
  const table = getRateTable();
  const zoneData = table[zone];
  if (!zoneData) return null;
  const packageData = zoneData[packageType];
  if (!packageData) return null;
  return packageData[duration] || null;
};

export const calculatePremium = (vehicleValue, rate, rateDivisor = RATE_DIVISOR) => {
  if (!rate || !vehicleValue) return 0;
  return (vehicleValue * rate) / rateDivisor;
};

// For backward compatibility while refactoring
export const rateTable = getRateTable();